const pad2 = (value) => String(value).padStart(2, '0');
const toIsoDate = (date) => `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;

/**
 * First/last day of the given date's month, as YYYY-MM-DD strings ready for a
 * native `<input type="date">`. Used to default the Auditor Utilization page's
 * From/To filters to "this month" on load, instead of an empty (all-time) range.
 */
export const getDefaultMonthRange = (referenceDate = new Date()) => {
  const year = referenceDate.getFullYear();
  const month = referenceDate.getMonth();
  const from = new Date(year, month, 1);
  const to = new Date(year, month + 1, 0);
  return { from: toIsoDate(from), to: toIsoDate(to) };
};

/**
 * Explicit inline colors (not Bootstrap's bg-success/bg-warning/bg-danger theme
 * classes) so the utilization badge stays high-contrast regardless of dark mode
 * or other theme overrides — same reasoning as CertificateLifecycleHealthCard's
 * MetricTile, which hit the same class of readability issue previously.
 * Foreground is always a light/white tone; background carries the color band.
 */
export const getUtilizationBadgeStyle = (percentage, hasCapacity) => {
  if (!hasCapacity) {
    return { backgroundColor: '#64748b', color: '#ffffff' };
  }
  const value = Number(percentage) || 0;
  if (value >= 80) {
    return { backgroundColor: '#dc2626', color: '#ffffff' };
  }
  if (value >= 50) {
    return { backgroundColor: '#d97706', color: '#ffffff' };
  }
  return { backgroundColor: '#16a34a', color: '#ffffff' };
};
